import React from 'react';
import PageHeader from '../../components/PageHeader';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const TerryBoes = () => {
  return (
    <div className="w-full bg-brand-light min-h-screen">
      <PageHeader 
        title="Terrance “Terry” Boes" 
        description="MBA, CEM, CFPS, CSP | Managing Partner"
      />

      <section className="py-20 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200 sticky top-28">
              <div className="aspect-square rounded-xl overflow-hidden mb-6 border-4 border-slate-50 shadow-inner bg-slate-100">
                <img src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1784999010215-blob" alt="Terry Boes" className="w-full h-full object-cover object-top" />
              </div>
              <h3 className="font-bold text-brand-navy mb-4 border-b border-slate-100 pb-2">Credentials</h3>
              <ul className="space-y-3 text-sm text-slate-700 font-medium">
                <li className="flex items-center gap-2"><SafeIcon icon={FiIcons.FiAward} className="text-brand-green" /> Certified Emergency Manager (CEM)</li>
                <li className="flex items-center gap-2"><SafeIcon icon={FiIcons.FiAward} className="text-brand-green" /> Certified Fire Protection Specialist (CFPS)</li>
                <li className="flex items-center gap-2"><SafeIcon icon={FiIcons.FiAward} className="text-brand-green" /> Certified Safety Professional (CSP)</li>
                <li className="flex items-center gap-2"><SafeIcon icon={FiIcons.FiAward} className="text-brand-green" /> NEBOSH Certification</li>
                <li className="flex items-center gap-2"><SafeIcon icon={FiIcons.FiBookOpen} className="text-brand-navy" /> MBA in Project Management</li>
                <li className="flex items-center gap-2"><SafeIcon icon={FiIcons.FiBookOpen} className="text-brand-navy" /> BS in Education</li>
                <li className="flex items-center gap-2"><SafeIcon icon={FiIcons.FiBookOpen} className="text-brand-navy" /> AA in Emergency Management</li>
              </ul>
            </div>
          </div>

          <div className="lg:col-span-8 prose prose-slate prose-lg">
            <div className="bg-white border-l-4 border-brand-navy p-6 rounded-r-xl shadow-sm mb-10">
              <h4 className="text-sm font-bold text-brand-green uppercase tracking-wider mb-2">Teaching Philosophy</h4>
              <p className="text-xl font-medium text-brand-navy italic m-0">
                "Every course should respond to the client's operation and the learners in the room. Boes & Boes does not rely on canned training."
              </p>
            </div>

            <p>
              Terry Boes brings over 27 years of experience as a firefighter and hazardous-materials specialist, having responded to more than 9,600 emergencies throughout his career. His background bridges the gap between complex regulatory requirements and practical, high-stress operational execution.
            </p>

            <h3 className="text-brand-navy font-bold">Disaster Response & Emergency Management</h3>
            <p>
              Terry's expertise goes far beyond the classroom. He has extensive real-world experience operating within private-facility Emergency Operations Centers (EOCs), State EOCs, and FEMA Joint Field Offices. His incident command and response experience includes:
            </p>
            <ul>
              <li>Hurricane Harvey response (2017)</li>
              <li>California wildfire response (2020)</li>
              <li>Florida hurricane response (2024)</li>
              <li>Multiple severe flood and tornado deployments</li>
            </ul>

            <h3 className="text-brand-navy font-bold">Instruction & Consulting</h3>
            <p>
              A former science teacher and deeply experienced adult instructor, Terry understands how to communicate complex technical information effectively. He is an authorized NFPA instructor and has served as an instructor for FEMA and the U.S. National Fire Academy.
            </p>
            <p>
              His consulting and teaching work spans more than 25 countries, serving domestic and international clients including URENCO USA, the Texas Division of Emergency Management, ICF, the U.S. Department of State, and the U.S. Department of Justice.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TerryBoes;